<div class="grid-container padding-y-4">
  <div class="grid-row">
    <div class="grid-col-8">
      <legend class="usa-legend usa-legend--large">TSP Approval</legend>
      <legend class="usa-legend usa-legend--medium" *ngIf="carrier">{{carrier.scac}} - {{carrier.scacName}}
        <span class="text-danger" *ngIf="isReadOnly">- Revoked</span></legend>
    </div>
    <div class="grid-col-4">
      <button class="usa-button usa-button--outline" (click)="goToHHgScope()" *ngIf="isHhgCarrier || isBothCarrier">
        Define Scope
      </button>
      <button class="usa-button usa-button--outline" (click)="gotToCarrierProfile()">Profile</button>
      <button class="usa-button usa-button--outline" routerLink="/agencytspsearch">Search</button>
    </div>
  </div>
  <div class="grid-row">
    <div class="usa-alert usa-alert--success usa-alert--no-icon" *ngIf="saveSuccessful">
      <div class="usa-alert__body">
        <p class="usa-alert__text">
          TSP Approval Information has been updated successfully
        </p>
      </div>
    </div>
  </div>
  <form [formGroup]="carrierApprovalForm">
    <fieldset class="usa-fieldset">
      <div class="grid-row grid-gap-1">
        <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-3 desktop:grid-col-3">
          <label for="type" class="usa-label">Approval Type</label>
          <select id="type" class="usa-select" formControlName="approvalType" (change)="changeApprovalType($event)">
            <option *ngIf="isHhgCarrier || isBothCarrier" value='Domestic HHG'>HHG Domestic</option>
            <option *ngIf="isHhgCarrier || isBothCarrier" value='International HHG'>HHG International</option>
            <option *ngIf="isHhgCarrier || isBothCarrier" value='HHG Rate Filing Service'>HHG Rate Filing Service</option>
            <!-- <option *ngIf="isHhgCarrier || isBothCarrier" value = 'OFM Vehicles' >OFM Vehicles</option>-->
            <option *ngIf="isHhgCarrier || isBothCarrier" value='Extended Storage HHG'>HHG Extended Storage</option>
            <option *ngIf="isFreightCarrier || isBothCarrier" value='Domestic FRT'>Freight TSP</option>
            <!--<option *ngIf="isFreightCarrier || isBothCarrier" value = 'Freight Rate Filing Service' >Freight Rate Filing Service</option>-->
          </select>
        </div>
        <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-3 desktop:grid-col-3" *ngIf='(this.carrierApprovalForm.value.approvalType==="Domestic HHG") || (this.carrierApprovalForm.value.approvalType==="International HHG")'>
          <label for="type" class="usa-label">US DOT <abbr *ngIf="this.carrierApprovalForm.value.approvalType==='Domestic HHG'" title="required" class="usa-hint usa-hint--required">*</abbr></label>
          <input type="text" formControlName="usDot" id="usDot" class="usa-input" maxlength="12" placeholder="US DOT Number" [readonly]='isReadOnly'>
          <div *ngIf="usDot.invalid && (usDot.dirty || usDot.touched) && (this.approvalType==='Domestic HHG')">
            <small *ngIf="usDot.errors?.required" class="define-text-secondary">
              <svg class="usa-icon" aria-hidden="true" focusable="false" role="img">
                <use xlink:href="/assets/uswds/img/sprite.svg#warning"></use>
              </svg>USDOT Number is required
            </small>
          </div>
          <div *ngIf="usDot.invalid && (usDot.dirty || usDot.touched)">
            <small *ngIf="usDot.errors?.minlength || usDot.errors?.maxlength" class="define-text-secondary">
              <svg class="usa-icon" aria-hidden="true" focusable="false" role="img">
                <use xlink:href="/assets/uswds/img/sprite.svg#warning"></use>
              </svg>USDOT must be 12 characters
            </small>
          </div>
          <div *ngIf="usDot.invalid && (usDot.dirty || usDot.touched)">
            <small *ngIf="usDot.errors?.pattern" class="define-text-secondary">
              <svg class="usa-icon" aria-hidden="true" focusable="false" role="img">
                <use xlink:href="/assets/uswds/img/sprite.svg#warning"></use>
              </svg>USDOT only has numbers
            </small>
          </div>
        </div>
        <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-3 desktop:grid-col-3" *ngIf='(this.carrierApprovalForm.value.approvalType==="Domestic HHG")'>
          <label for="type" class="usa-label"> &#8203; </label>
          <div class="usa-checkbox">
            <input
              class="usa-checkbox__input" [readonly]='isReadOnly'
              id="intraState-Scope"
              type="checkbox" formControlName="intraStateScope" (change)="onIntraStateScope($event)"/>
            <label class="usa-checkbox__label" for="intraState-Scope">Approved for Intrastate Scope Only</label>
          </div>
        </div>

      </div>

      <div class="grid-row grid-gap-1" *ngIf='(this.carrierApprovalForm.value.approvalType==="Domestic HHG") || (this.carrierApprovalForm.value.approvalType==="International HHG")'>
        <legend class="usa-legend usa-legend--small text-bold">Data must be entered for at least one of the following fields.
          <span *ngIf='(this.carrierApprovalForm.value.approvalType==="Domestic HHG")'>
            unless “Approved for Intrastate Scope Only” is checked
          </span>
        </legend>
      </div>
      <div class="grid-row grid-gap-1">
        <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-3 desktop:grid-col-3" *ngIf='(this.carrierApprovalForm.value.approvalType==="International HHG")'>
          <label for="type" class="usa-label">FMC OTI</label>
          <input type="text" formControlName="fmcOTI" id="fmcOTI" class="usa-input" maxlength="12" placeholder="FMC OTI Number" [readonly]='isReadOnly'>
          <div *ngIf="(this.carrierApprovalForm.hasError('oneOfThreeHasValue')) && (this.approvalType==='International HHG')">
            <small class="define-text-secondary">
              <svg class="usa-icon" aria-hidden="true" focusable="false" role="img">
                <use xlink:href="/assets/uswds/img/sprite.svg#warning"></use>
              </svg>FMC OTI#, MC# or FF# must be entered
            </small>
          </div>
          <div *ngIf="fmcOTI.invalid && (fmcOTI.dirty || fmcOTI.touched)">
            <small *ngIf="fmcOTI.errors?.minlength || fmcOTI.errors?.maxlength" class="define-text-secondary">
              <svg class="usa-icon" aria-hidden="true" focusable="false" role="img">
                <use xlink:href="/assets/uswds/img/sprite.svg#warning"></use>
              </svg>FMC OTI must be 12 characters
            </small>
          </div>
          <div *ngIf="fmcOTI.invalid && (fmcOTI.dirty || fmcOTI.touched)">
            <small *ngIf="fmcOTI.errors?.pattern" class="define-text-secondary">
              <svg class="usa-icon" aria-hidden="true" focusable="false" role="img">
                <use xlink:href="/assets/uswds/img/sprite.svg#warning"></use>
              </svg>FMC OTI only has numbers
            </small>
          </div>
        </div>

        <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-3 desktop:grid-col-3" *ngIf='(this.carrierApprovalForm.value.approvalType==="Domestic HHG") || (this.carrierApprovalForm.value.approvalType==="International HHG")'>
          <label class="usa-label">Motor Common Carrier Authority</label>
          <input maxlength="12" id="mcNumber" class="usa-input" formControlName="inputMCNumber" type="tel" placeholder="MC Number" [readonly]='isReadOnly'>
          <div *ngIf="(this.carrierApprovalForm.hasError('oneOfThreeHasValue')) && (this.approvalType==='International HHG')">
            <small class="define-text-secondary">
              <svg class="usa-icon" aria-hidden="true" focusable="false" role="img">
                <use xlink:href="/assets/uswds/img/sprite.svg#warning"></use>
              </svg>FMC OTI#, MC# or FF# must be entered
            </small>
          </div>
          <div *ngIf="this.carrierApprovalForm.hasError('oneOfTwoHasValue') && approvalType==='Domestic HHG'">
            <small class="define-text-secondary">
              <svg class="usa-icon" aria-hidden="true" focusable="false" role="img">
                <use xlink:href="/assets/uswds/img/sprite.svg#warning"></use>
              </svg>MC Number or FF Number must be entered
            </small>
          </div>
          <div *ngIf="inputMCNumber.invalid && (inputMCNumber.dirty || inputMCNumber.touched)">
            <small *ngIf="inputMCNumber.errors?.required" class="define-text-secondary">
              <svg class="usa-icon" aria-hidden="true" focusable="false" role="img">
                <use xlink:href="/assets/uswds/img/sprite.svg#warning"></use>
              </svg>MC Number is required
            </small>
          </div>
          <div *ngIf="inputMCNumber.invalid && (inputMCNumber.dirty || inputMCNumber.touched)">
            <small *ngIf="inputMCNumber.errors?.minlength || inputMCNumber.errors?.maxlength" class="define-text-secondary">
              <svg class="usa-icon" aria-hidden="true" focusable="false" role="img">
                <use xlink:href="/assets/uswds/img/sprite.svg#warning"></use>
              </svg>MC Number must be 12 characters
            </small>
          </div>
          <div *ngIf="inputMCNumber.invalid && (inputMCNumber.dirty || inputMCNumber.touched)">
            <small *ngIf="inputMCNumber.errors?.pattern" class="define-text-secondary">
              <svg class="usa-icon" aria-hidden="true" focusable="false" role="img">
                <use xlink:href="/assets/uswds/img/sprite.svg#warning"></use>
              </svg>MC Number only has numbers
            </small>
          </div>
        </div>

        <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-3 desktop:grid-col-3" *ngIf='(this.carrierApprovalForm.value.approvalType==="Domestic HHG") || (this.carrierApprovalForm.value.approvalType==="International HHG")'>
          <label class="usa-label" for="ff-number">Freight Forwarder Authority</label>
          <input type="text" id="ffNumber" class="usa-input" formControlName="inputFFNumber" maxlength="12" placeholder="FF Number" [readonly]='isReadOnly'>
          <div *ngIf="(this.carrierApprovalForm.hasError('oneOfThreeHasValue')) && (this.approvalType==='International HHG')">
            <small class="define-text-secondary">
              <svg class="usa-icon" aria-hidden="true" focusable="false" role="img">
                <use xlink:href="/assets/uswds/img/sprite.svg#warning"></use>
              </svg>FMC OTI#, MC# or FF# must be entered
            </small>
          </div>
          <div *ngIf="this.carrierApprovalForm.hasError('oneOfTwoHasValue') && (approvalType==='Domestic HHG')">
            <small class="define-text-secondary">
              <svg class="usa-icon" aria-hidden="true" focusable="false" role="img">
                <use xlink:href="/assets/uswds/img/sprite.svg#warning"></use>
              </svg><span *ngIf="approvalType==='Domestic HHG'">MC Number or</span> FF Number must be entered
            </small>
          </div>
          <div *ngIf="inputFFNumber.invalid && (inputFFNumber.dirty || inputFFNumber.touched)">
            <small *ngIf="inputFFNumber.errors?.required" class="define-text-secondary">
              <svg class="usa-icon" aria-hidden="true" focusable="false" role="img">
                <use xlink:href="/assets/uswds/img/sprite.svg#warning"></use>
              </svg>FF Number is required
            </small>
          </div>
          <div *ngIf="inputFFNumber.invalid && (inputFFNumber.dirty || inputFFNumber.touched)">
            <small *ngIf="inputFFNumber.errors?.minlength || inputFFNumber.errors?.maxlength" class="define-text-secondary">
              <svg class="usa-icon" aria-hidden="true" focusable="false" role="img">
                <use xlink:href="/assets/uswds/img/sprite.svg#warning"></use>
              </svg>FF Number must be 12 characters
            </small>
          </div>
          <div *ngIf="inputFFNumber.invalid && (inputFFNumber.dirty || inputFFNumber.touched)">
            <small *ngIf="inputFFNumber.errors?.pattern" class="define-text-secondary">
              <svg class="usa-icon" aria-hidden="true" focusable="false" role="img">
                <use xlink:href="/assets/uswds/img/sprite.svg#warning"></use>
              </svg>FF Number only has numbers
            </small>
          </div>
        </div>
      </div>
      <hr>
      <div class="grid-row">
        <legend class="usa-legend usa-legend--medium">TSP Information</legend>
      </div>
      <div class="grid-row grid-gap-1">
        <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-3 desktop:grid-col-3">
          <label for="tpa_id" class="usa-label">TPA ID<abbr title="required"
                                                            class="usa-hint usa-hint--required">*</abbr></label>
          <input type="text" id="tpa_id" class="usa-input" formControlName="tpaId" maxlength="6" [readonly]='isReadOnly'>
          <div *ngIf="this.carrierApprovalForm.get('tpaId').invalid">
            <small class="define-text-secondary">
              <svg class="usa-icon" aria-hidden="true" focusable="false" role="img">
                <use xlink:href="/assets/uswds/img/sprite.svg#warning"></use>
              </svg>TPA ID is required
            </small>
          </div>
        </div>
        <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-3 desktop:grid-col-3">
          <label for="tpa_id" class="usa-label">Date Approved<abbr title="required"
                                                                   class="usa-hint usa-hint--required">*</abbr></label>
          <input type="text" id="dateApproved" class="usa-input" placeholder="mm/dd/yyyy"
                 (bsValueChange)="changeSlider($event, 'approved')" formControlName="dateApproved" name="dateApproved"
                 [value]="this.carrierApprovalForm.get('dateApproved').value | date: 'MMM d, y'"
                 bsDatepicker
                 [bsConfig]="{ dateInputFormat: 'MMM D, YYYY' }"
                 placement="right" [maxDate]="maxDate">
          <div *ngIf="this.carrierApprovalForm.get('dateApproved').invalid">
            <small class="define-text-secondary">
              <svg class="usa-icon" aria-hidden="true" focusable="false" role="img">
                <use xlink:href="/assets/uswds/img/sprite.svg#warning"></use>
              </svg>Date Approved is required
            </small>
          </div>
        </div>

        <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-3 desktop:grid-col-3">
          <label for="tsp_csi" class="usa-label">Date Placed in Temporary Non-Use</label>
          <input type="text" id="dateSuspended" class="usa-input" placeholder="mm/dd/yyyy"
                 (bsValueChange)="changeSlider($event, 'suspended')" formControlName="dateSuspended"
                 [value]="this.carrierApprovalForm.get('dateSuspended').value | date: 'MMM d, y'"
                 bsDatepicker
                 [bsConfig]="{ dateInputFormat: 'MMM D, YYYY' }"
                 [maxDate]="maxDate" placement="right" name="dateSuspended">
          <div *ngIf="invalidDate">
            <small class="define-text-secondary">
              <svg class="usa-icon" aria-hidden="true" focusable="false" role="img">
                <use xlink:href="/assets/uswds/img/sprite.svg#warning"></use>
              </svg>Date Suspended must be greater than Date Approved
            </small>
          </div>
        </div>
      </div>
      <div class="grid-row grid-gap-1">
        <div class="grid-col-2 padding-top-5">
          <label class="switch">
            <input type="checkbox" id="appvedSlider" formControlName="appvedSlider" [readonly]='isReadOnly'>
            <span class="slider round"></span>
          </label>
          <span class="padding-left-2">Approved</span>
        </div>
        <div class="grid-col-2" *ngIf="showCSI">
          <label class="usa-label">Customer Satisfaction Index: {{this.carrierApprovalForm.get('tspCSI').value}}</label>
        </div>
      </div>
      <div class="grid-row grid-gap-1">
        <div class="grid-col-4">
          <label for="approval_notes" class="usa-label">Notes:<abbr title="required" class="usa-hint usa-hint--required">*</abbr>
            <button type="button" class="usa-button margin-left-2"  (click) = "messageHistoryModal()" > Notes History</button>
          </label>
          <textarea id="approval_notes" class="usa-textarea" maxlength="5000"
                    formControlName="approvalNotes"></textarea>
        </div>
      </div>
      <hr>
      <div class="grid-row">
        <legend class="usa-legend usa-legend--medium">Socio-Economic Indicators</legend>
      </div>
      <div class="grid-row">
        <fieldset class="usa-fieldset">
          <div class="usa-checkbox">
            <input class="usa-checkbox__input" id="smallbiz" type="checkbox" formControlName="smallBiz" />
            <label class="usa-checkbox__label" for="smallbiz">Small Business (s)</label>
          </div>
          <div class="usa-checkbox">
            <input class="usa-checkbox__input" id="otherThanSmallBiz" type="checkbox" formControlName="otherThanSmallBiz" />
            <label class="usa-checkbox__label" for="otherThanSmallBiz">Other than Small Business (o)</label>
          </div>
          <div class="usa-checkbox">
            <input class="usa-checkbox__input" id="womenBiz" type="checkbox" formControlName="womenBiz"/>
            <label class="usa-checkbox__label" for="womenBiz">Women Owned Business (w)</label>
          </div>
          <div class="usa-checkbox">
            <input class="usa-checkbox__input" id="veteranBiz" type="checkbox" formControlName="veteranBiz"/>
            <label class="usa-checkbox__label" for="veteranBiz">Veteran Owned Small Business (v)</label>
          </div>
          <div class="usa-checkbox">
            <input class="usa-checkbox__input" id="disabledbiz" type="checkbox" formControlName="disabledVetBiz" />
            <label class="usa-checkbox__label" for="disabledbiz">Service Disabled Veteran Owned Small Business (dv)</label>
          </div>
          <div class="usa-checkbox">
            <input class="usa-checkbox__input" id="sbaBiz" type="checkbox" formControlName="sbaBiz" />
            <label class="usa-checkbox__label" for="sbaBiz">SBA Certified Small Disadvantaged Business (d)</label>
          </div>
          <div class="usa-checkbox">
            <input class="usa-checkbox__input" id="firm8a" type="checkbox" formControlName="firm8a"/>
            <label class="usa-checkbox__label" for="firm8a">SBA Certified 8(a) firm (8a)</label>
          </div>
          <div class="usa-checkbox">
            <input class="usa-checkbox__input" id="hubZone" type="checkbox" formControlName="hubZone" />
            <label class="usa-checkbox__label" for="hubZone">SBA Certified HUBZone firm (h)</label>
          </div>
        </fieldset>
      </div>
      <hr>
      <div class="grid-row grid-gap-1" *ngIf="showBondInfo">
        <legend class="usa-legend usa-legend--medium">Bond Information</legend>
      </div>
      <div class="grid-row grid-gap-1" *ngIf="showBondInfo">
        <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-4 desktop:grid-col-4">
          <label for="bond_no" class="usa-label">Bond Number</label>
          <input type="text" id="bond_no" class="usa-input" maxlength="20" formControlName="bondNum" [readonly]='isReadOnly'
                 (change)="validateBondInfo()">
        </div>
        <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-4 desktop:grid-col-4">
          <label for="bond_expire" class="usa-label">Expiration Date</label>
          <input type="text" id="bond_expire" class="usa-input" placeholder="mm/dd/yyyy"
                 formControlName="bondExpDate" (focus)="onFocusBondDate($event)" (focusout)="onFocusOutBondDate($event)"
                 [value]="this.carrierApprovalForm.get('bondExpDate').value | date: 'MMM d, y'" [minDate]="this.minDate"
                 bsDatepicker
                 [bsConfig]="{ dateInputFormat: 'MMM D, YYYY' }"
                 placement="right">
          <div *ngIf="bondReq">
            <small class="text-danger">
              <span class="fa fa-warning"></span> Bond Expiration date is required
            </small>
          </div>
        </div>
      </div>
      <div class="grid-row" *ngIf="showInsure">
        <legend class="usa-legend usa-legend--medium">Insurance Information</legend>
      </div>
      <div class="grid-row grid-gap-1" *ngIf="showInsure">
        <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-4 desktop:grid-col-4">
          <label for="insur_name" class="usa-label">Insurance Short Name<abbr title="required"
                                                                              class="usa-hint usa-hint--required">*</abbr></label>
          <input type="text" id="insur_name" class="usa-input" maxlength="4" formControlName="insurName" [readonly]='isReadOnly'
                 (change)="onInsuranceShortNameChange()">
          <div *ngIf="insureNameReqd">
            <small class="define-text-secondary">
              <svg class="usa-icon" aria-hidden="true" focusable="false" role="img">
                <use xlink:href="/assets/uswds/img/sprite.svg#warning"></use>
              </svg>Insurance Name is required
            </small>
          </div>
        </div>
        <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-4 desktop:grid-col-4" *ngIf="isInsuranceShortNamePresent">
          <label for="insur_no" class="usa-label">Insurance Number<abbr title="required"
                                                                        class="usa-hint usa-hint--required">*</abbr></label>
          <input type="text" id="insur_no" class="usa-input" maxlength="20" formControlName="insurNum" [readonly]='isReadOnly'>
          <div *ngIf="this.carrierApprovalForm.get('insurNum').invalid">
            <small class="define-text-secondary">
              <svg class="usa-icon" aria-hidden="true" focusable="false" role="img">
                <use xlink:href="/assets/uswds/img/sprite.svg#warning"></use>
              </svg>Insurance Number is required
            </small>
          </div>
        </div>
        <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-4 desktop:grid-col-4" *ngIf="isInsuranceShortNamePresent">
          <label for="insur_expire" class="usa-label">Expiration Date<abbr title="required"
                                                                           class="usa-hint usa-hint--required">*</abbr></label>
          <input type="text" id="insur_expire" class="usa-input" placeholder="mm/dd/yyyy" formControlName="insurExpDate"
                 [value]="this.carrierApprovalForm.get('insurExpDate').value | date: 'MMM d, y'"
                 [minDate]="this.minDate" bsDatepicker [bsConfig]="datePickerConfig" placement="right">
          <div *ngIf="this.carrierApprovalForm.get('insurExpDate').invalid">
            <small class="define-text-secondary">
              <svg class="usa-icon" aria-hidden="true" focusable="false" role="img">
                <use xlink:href="/assets/uswds/img/sprite.svg#warning"></use>
              </svg>Insurance Expiration Date is required
            </small>
          </div>
        </div>
      </div>
      <div class="grid-row margin-top-4">
        <ul class="usa-button-group">
          <li class="usa-button-group__item" *ngIf="!isReadOnly">
            <button type="button" class="usa-button"
                    [disabled]="carrierApprovalForm.invalid || saveSuccessful || invalidDate"
                    (click)="saveCarrierApproval();">Save
            </button>
          </li>
          <li class="usa-button-group__item">
            <button type="button" class="usa-button" (click)="viewAuditTrial()">View Audit Trail</button>
          </li>
          <li class="usa-button-group__item" *ngIf="this.enableRevokeBtn && !this.isReadOnly">
            <button type="button" class="usa-button" [disabled]="this.carrierApprovalForm.get('approvalNotes').value === ''"
                    (click)="deleteCarrierData()">Revoke {{carrierApprovalForm.get('approvalType').value}} Only</button>
          </li>
          <li class="usa-button-group__item" *ngIf="isReadOnly">
            <button type="button" class="usa-button"
                    [disabled]="this.carrierApprovalForm.get('approvalNotes').value === ''"
                    (click)="reinstateApproval()">Reinstate {{carrierApprovalForm.get('approvalType').value}}</button>
          </li>
        </ul>
      </div>
    </fieldset>
  </form>
</div>
